import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;
const REND_ADMIN_ENDPOINT = `${REACT_APP_REST_ENDPOINT}/rendicontazione-admin`;

const RendicontazioneAdminService = {
    _handleJsonResponse: async (response) => {
        if (response.ok) {
            // Se la risposta è OK, prova a leggerla come JSON
            const text = await response.text();
            return text ? JSON.parse(text) : {}; // Gestisce risposte vuote
        } else {
            // Se c'è un errore, leggi il messaggio di errore dal backend
            const error = await response.json().catch(() => ({ message: `Errore del server: ${response.statusText}` }));
            throw new Error(error.message || "Si è verificato un errore di comunicazione");
        }
    },
    find(filtri) {
        const url = `${REND_ADMIN_ENDPOINT}/find`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, filtri);
        });
    },

    updateStatus(data) {
        const url = `${REND_ADMIN_ENDPOINT}/update-status`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    },

    liquidate(formData) {
        const token = localStorage.getItem("token");
        return fetch(`${REND_ADMIN_ENDPOINT}/liquida`, {
            method: 'POST',
            headers: {
                // Per i FormData, NON impostiamo 'Content-Type'. Il browser lo fa per noi.
                'Authorization': `Bearer ${token}`
            },
            body: formData
        }).then(this._handleJsonResponse);
    },
    findLiquidate(filtri) {
        const url = `${REND_ADMIN_ENDPOINT}/find-liquidate`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, filtri);
        });
    },
    getDettaglio(id_rendicontazione) {
        const url = `${REND_ADMIN_ENDPOINT}/get-dettaglio`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, { id_rendicontazione });
        });
    },

    findSuperpartner(filtri) {
        const url = `${REND_ADMIN_ENDPOINT}/find-superpartner`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, filtri);
        });
    },

    updateStatusSuperpartner(data) {
        const url = `${REND_ADMIN_ENDPOINT}/update-status-superpartner`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    },

    liquidateSuperpartner(formData) {
        const token = localStorage.getItem("token");
        return fetch(`${REND_ADMIN_ENDPOINT}/liquida-superpartner`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            body: formData
        }).then(this._handleJsonResponse);
    },
    
    findLiquidateSuperpartner(filtri) {
        const url = `${REND_ADMIN_ENDPOINT}/find-liquidate-superpartner`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, filtri);
        });
    },

    getDettaglioSuperpartner(id_rendicontazione) {
        const url = `${REND_ADMIN_ENDPOINT}/get-dettaglio-superpartner`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, { id_rendicontazione });
        });
    },

    getLiquidazioneAnnualeSuperpartner(id_superpartner, anno, id_corso) {
        const url = `${REND_ADMIN_ENDPOINT}/liquidazione-annuale-superpartner`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, { id_superpartner, anno, id_corso });
        });
    },

    getCorsiLiquidazione(id_superpartner) {
        const url = `${REND_ADMIN_ENDPOINT}/corsi-liquidazione`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, { id_superpartner });
        });
    },

    getRiepilogoLiquidazioneAnnuale(id_superpartner, anno) {
        const url = `${REND_ADMIN_ENDPOINT}/riepilogo-liquidazione-annuale`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, { id_superpartner, anno });
        });
    }
};

export default RendicontazioneAdminService;